import ParserAutoComplete from "./dynamicInputs/ParserAutoComplete";
import ParserTextField from "./dynamicInputs/ParserTextField";
import YearAutoComplete from "./dynamicInputs/YearAutoComplete";
import CityAutoComplete from "./dynamicInputs/CityAutoComplete";
import CompanyAutoComplete from "./dynamicInputs/CompanyAutoComplete";
import LocationAutoComplete from "./dynamicInputs/LocationAutoComplete";

export const DynamicFieldEditor = ({
    value,
    type,
    fieldName,
    formControls,
    options,
    disabled,
    required = false,
}) => {
    const commonProps = {
        disabled,
        value,
        fieldName,
        formControls,
    };

    switch (type) {
        case "city":
            return <CityAutoComplete {...commonProps} />;

        case "year":
            return (
                <YearAutoComplete
                    {...commonProps}
                    type={type}
                    multiple={false}
                    options={options}
                />
            );

        case "company":
            return (
                <CompanyAutoComplete
                    {...commonProps}
                    type={type}
                    freeSolo={type === "company"}
                    required={required}
                />
            );
        case "autocomplete":
            return (
                <ParserAutoComplete
                    {...commonProps}
                    type={type}
                    multiple={false}
                    freeSolo={type === "company"}
                    options={options}
                />
            );

        case "university":
        case "department":
            return (
                <ParserAutoComplete
                    multiple={false}
                    freeSolo={true}
                    options={options}
                    {...commonProps}
                />
            );
        case "location":
            return (
                <LocationAutoComplete
                    {...commonProps}
                    type={type}
                    multiple={false}
                    freeSolo={true}
                />
            );
        case "skills":
            return (
                <ParserAutoComplete
                    {...commonProps}
                    type={type}
                    multiple={true}
                    freeSolo={false}
                    options={options}
                />
            );
        case "jobFunctions":
            return (
                <ParserAutoComplete
                    {...commonProps}
                    type={type}
                    multiple={true}
                    freeSolo={false}
                    options={options}
                />
            );
        case "occupations":
            return (
                <ParserAutoComplete
                    {...commonProps}
                    type={type}
                    multiple={true}
                    freeSolo={false}
                    options={options}
                />
            );

        case "options":
            return null;

        case "number":
            return <ParserTextField {...commonProps} type={type} />;
        case "text":
        case "textarea":
        case "date":
            return <ParserTextField {...commonProps} type={type} />;

        default:
            return <ParserTextField {...commonProps} type="text" />;
    }
};

export default DynamicFieldEditor;
